export const SET_MESSAGE_TEMPLATE = "@SETTINGS/MESSAGE_TEMPLATE/SET_MESSAGE_TEMPLATE";
export const SET_MESSAGE_TEMPLATE_LIST = "@SETTINGS/MESSAGE_TEMPLATE/SET_MESSAGE_TEMPLATE_LIST";
export const SET_TEMPLATE_DATA = "@SETTINGS/MESSAGE_TEMPLATE/SET_TEMPLATE_DATA";
export const SET_TEMPLATE_TYPE_LIST = "@SETTINGS/MESSAGE_TEMPLATE/SET_TEMPLATE_TYPE_LIST";
export const RESET_MESSAGE_TEMPLATE = "@SETTINGS/MESSAGE_TEMPLATE/RESET_MESSAGE_TEMPLATE";
